<template>
  <div>
    <HeaderPage href="/joinUs" />
    <div class="container_wrap">
      <div class="neiBanner">
        <div class="textBanner wow">
          <dl>JOIN GUOZHENG</dl>
          <div class="solid"></div>
          <dt>加入国正</dt>
        </div>
      </div>

      <div class="employeeWorld">
        <div class="wrap">
          <div class="ntitle wow">
            <h3>EMPLOYEE WORLD</h3>
            <h2>员工天地</h2>
          </div>
          <div class="box wow">
            <div class="swiper swiper-container-horizontal">
              <div class="swiper-wrapper">
                <div class="swiper-slide imgZoom swiper-slide-duplicate swiper-slide-active swiper-slide-duplicate-next"
                  data-swiper-slide-index="0" style="width: 530px; margin-right: 45px;">
                  <dl class="imgBoxCover"><img src="@/assets/images/4duRXd.jpg" alt=""></dl>
                  <h3>公司组织员工端午金华、丽水两日游</h3>
                </div>
                <div class="swiper-slide imgZoom swiper-slide-duplicate swiper-slide-active swiper-slide-duplicate-next"
                  data-swiper-slide-index="0" style="width: 530px; margin-right: 45px;">
                  <dl class="imgBoxCover"><img src="@/assets/images/4duRXd.jpg" alt=""></dl>
                  <h3>公司组织员工端午金华、丽水两日游</h3>
                </div>
                <!-- <div class="swiper-slide imgZoom swiper-slide-duplicate swiper-slide-active swiper-slide-duplicate-next"
                  data-swiper-slide-index="0" style="width: 530px; margin-right: 45px;">
                  <dl class="imgBoxCover"><img src="@/assets/images/4duRXd.jpg" alt=""></dl>
                  <h3>公司组织员工端午金华、丽水两日游</h3>
                </div> -->
              </div>
              <div class="pagination swiper-pagination-clickable swiper-pagination-bullets">
                <span class="swiper-pagination-bullet swiper-pagination-bullet-active"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="job">
        <div class="wrap">
          <div class="ntitle wow">
            <h3>TALENT RECRUITMENT</h3>
            <h2>人才招聘</h2>
          </div>
          <div class="box wow ">
            <ul>
              <li>
                <div class="item" @click="detail">
                  <div class="tit">
                    <h3>销售经理</h3>
                  </div>
                  <div class="text">较强的事业心和责任感，抗压能力强，良好的团队协作精神与合作意识，及较强的人际协调能力，有志于在销售行业长期发展。</div>
                  <div class="con">
                    <h3>职位详情</h3>
                    招聘城市：绍兴柯桥<br>
                    岗位职责：<br>
                    1、按照公司下达的销售目标制定销售计划和销售策略；<br>
                    2、带领和管理销售团队完成销售目标和计划，监督和指导下属工作；<br>
                    3、定期组织销售培训和销售会议，关注团队成长，提升团队业绩，营造有战斗力和学习力的团队氛围。<br>
                    任职要求：<br>
                    1、大专及以上学历，有3年以上计师等从业经历者优先；<br>
                    2、有1年以上团队管理经验；<br>
                    3、形象气质佳、性格外向、反应敏捷、谈吐流利；<br>
                    4、较强的事业心和责任感，抗压能力强，良好的团队协作精神与合作意识，及较强的人际协调能力，有志于在销售行业长期发展。<br>
                    简历递交邮箱：guozhengjiance@163.com
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <FooterPage />
  </div>
  <!-- 弹出框 -->
  <div class="tccBox">
    <div class="black"></div>
    <div class="BoxCon">
      <div class="off" @click="off"></div>
      <div class="textCon">
        <h3>职位详情</h3>
        招聘城市：绍兴柯桥<br>
        岗位职责：<br>
        1、按照公司下达的销售目标制定销售计划和销售策略；<br>
        2、带领和管理销售团队完成销售目标和计划，监督和指导下属工作；<br>
        3、定期组织销售培训和销售会议，关注团队成长，提升团队业绩，营造有战斗力和学习力的团队氛围。<br>
        任职要求：<br>
        1、大专及以上学历，有3年以上计师等从业经历者优先；<br>
        2、有1年以上团队管理经验；<br>
        3、形象气质佳、性格外向、反应敏捷、谈吐流利；<br>
        4、较强的事业心和责任感，抗压能力强，良好的团队协作精神与合作意识，及较强的人际协调能力，有志于在销售行业长期发展。<br>
        简历递交邮箱：guozhengjiance@163.com
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';
// 组件逻辑
import HeaderPage from '@/components/HeaderPage.vue'
import FooterPage from '@/components/FooterPage.vue'


let intervalId


const stopAutoScroll = () => {
  clearInterval(intervalId)
}

const detail = () => {
  const tccBox = document.querySelectorAll('.tccBox')
  tccBox.forEach(element => {
    element.style.display = 'block';
  });
}

const off = () => {
  const tccBox = document.querySelectorAll('.tccBox')
  tccBox.forEach(element => {
    element.style.display = 'none';
  });
}

onMounted(() => {

  // ✅ 滚动动画逻辑
  const elements = document.querySelectorAll('.wow')
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target
        const animateName = el.dataset.animate || 'fadeInUp'
        if (entry.isIntersecting) {
          el.classList.add('animated', animateName)
          // ✅ 添加后立即取消观察，避免重复触发
          observer.unobserve(el)
        }
      })
    },
    { threshold: 0.2 }
  )
  elements.forEach((el) => observer.observe(el))
  onUnmounted(() => {
    elements.forEach((el) => observer.unobserve(el))
    stopAutoScroll()
  })
})

</script>

<style scoped>
.neiBanner {
  height: 500px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: url('@/assets/images/bg/3xqozo.jpg');
}

.neiBanner .textBanner {
  color: #fff;
  text-align: center;
}

.neiBanner .textBanner .solid {
  height: 1px;
  background-color: #fff;
  margin: 15px 0;
  box-sizing: border-box;
}

.neiBanner .textBanner dl {
  font-size: 42px;
}

.neiBanner .textBanner dt {
  font-size: 20px;
  font-weight: 500;
}

.employeeWorld {
  padding: 50px 0;
}

.ntitle {
  text-align: center;
  margin-bottom: 50px;
}

.ntitle h3 {
  font-size: 38px;
  line-height: 1;
  color: #003366;
  font-weight: 500;
  border-bottom: #003366 solid 1px;
  display: inline-block;
  padding: 0 0 15px;
  margin-bottom: 15px;
}

.ntitle h2 {
  font-size: 36px;
  line-height: 1;
  color: #333;
  font-weight: 500;
}

.employeeWorld .swiper {
  overflow: hidden;
}

.job {
  padding: 30px 0 120px;
}

.job .box ul {
  width: 100%;
}

.job .box ul li {
  margin-bottom: 30px;
}

.job .box ul li .item {
  border-bottom: #d3d3d3 solid 1px;
  padding: 20px 80px 20px 20px;
  cursor: pointer;
  position: relative;
}

.job .box ul li .item .tit {
  margin-bottom: 10px;
}

.job .box ul li .item .tit h3 {
  font-size: 24px;
  line-height: 1;
}

.job .box ul li .item .text {
  font-size: 14px;
  color: #666;
}

.job .box ul li .item .con {
  display: none;
}
</style>